export default __webpack_public_path__ + "static/media/Res_User_48_Dark.ec989584.svg";